import { useEffect } from 'react';

import { NextRouter } from 'next/router';

import { User } from '@lessonPlanner/commons';
import { OrganizationSource } from '@lessonPlanner/enums';

import { routes } from '../../constants/routes';
import { updateAccountSources } from '../../utils/server-side/account';

interface UseCerebroRedirectProps {
  isSignedIn: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  redirectId: OrganizationSource;
  router: NextRouter;
}

export function useCerebroRedirect({
  isSignedIn,
  data,
  redirectId,
  router,
}: UseCerebroRedirectProps): void {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (isSignedIn && redirectId === OrganizationSource.CEREBRO) {
      if (
        !(data as unknown as { user: User }).user?.accountSources?.includes(
          redirectId,
        )
      ) {
        updateSources();
      }

      redirectToCerebro();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, data, redirectId]);

  const redirectToCerebro = () => {
    if (
      data?.user?.organizations?.some(
        (org) => org.name.toUpperCase() === OrganizationSource.CEREBRO,
      )
    ) {
      router.push(routes.CEREBRO_LESSON_PLAN);
    }
  };

  const updateSources = async () => {
    await updateAccountSources({
      accountSource: redirectId,
      userId: (data as unknown as { user: User }).user.id,
    });
  };
}
